module.exports = MaterialUI.FormControlLabel;